import type { TimelineEvent } from '@/mocks/types';

const TAG_STYLE: Record<string, string> = {
  反转: 'bg-accent-500 text-accent-950',
  回应: 'bg-secondary-500 text-background-50',
  发酵: 'bg-primary-500 text-background-50',
  源头: 'bg-primary-500 text-background-50',
  存疑: 'bg-accent-100 text-accent-900',
  归档: 'bg-background-300 text-foreground-700',
  溯源: 'bg-secondary-100 text-secondary-900',
  分析: 'bg-secondary-100 text-secondary-900',
};

export default function ArticleTimeline({ events }: { events: TimelineEvent[] }) {
  return (
    <ol className="relative border-l-2 border-background-200 pl-6 md:pl-8">
      {events.map((item) => (
        <li key={`${item.date}-${item.title}`} className="relative pb-8 last:pb-0">
          <span className="absolute -left-[31px] top-2 h-3.5 w-3.5 rounded-full border-2 border-background-50 bg-primary-500 md:-left-[39px]"></span>
          <div className="rounded-lg border border-background-200 bg-background-50 p-5">
            <div className="flex flex-wrap items-center gap-3">
              <span className="font-heading text-sm font-bold text-foreground-950">{item.date}</span>
              <span
                className={`rounded-full px-2.5 py-0.5 text-[11px] font-medium ${
                  TAG_STYLE[item.tag] || 'bg-background-200 text-foreground-700'
                }`}
              >
                {item.tag}
              </span>
            </div>
            <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">{item.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
          </div>
        </li>
      ))}
    </ol>
  );
}